/** @jsxImportSource @emotion/react */
import { PublicPageRoute } from 'enums';
import AuthenticatedLayout from 'global/authenticated-layout';

import { ErrorPage, SignUpPage } from 'pages';
import { Route, Routes } from 'react-router-dom';

const Layout = (): JSX.Element => {
  return (
    <>
      <Routes>
        {/* Public routes - no authentication required */}
        <Route path={PublicPageRoute.Error} element={<ErrorPage />}></Route>
        <Route path={PublicPageRoute.SignUp} element={<SignUpPage />}></Route>

        {/* All other routes require authentication */}
        <Route path="*" element={<AuthenticatedLayout />}></Route>
      </Routes>
    </>
  );
};

export default Layout;
